var _path, _path2, _circle;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestionsNordyne(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 94 94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "questionBubbleFill",
    d: "M47,94c-8.4394,0-16.7249-2.2704-23.9587-6.5687l-.7732-.4587-20.499,5.2583,4.8946-21.1018-.439-.7633C2.1524,63.2728,0,55.1937,0,47,0,21.0822,21.0822,0,47,0s47,21.0822,47,47-21.0822,47-47,47"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "questionMarkFill",
    d: "M52.1816,32.4716c0-3.5624-2.3188-6.0389-6.2665-6.0389-3.0928,0-5.567,1.624-7.8113,3.9481l-5.1039-4.6451c3.4814-3.9481,8.1999-6.7358,14.0777-6.7358,8.1189,0,13.9223,4.4117,13.9223,12.8525,0,9.8314-11.9889,13.2383-10.985,23.1475h-7.9667c-1.6225-11.2253,10.1332-15.6402,10.1332-22.5284"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "questionMarkFill",
    cx: 46,
    cy: 67,
    r: 6
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionsNordyne);
export default __webpack_public_path__ + "static/media/questions-Nordyne.c98f9d1a340e028a06e18441f1b38ee9.svg";
export { ForwardRef as ReactComponent };